













import { Vue, Component, Prop } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";

@Component ({
  components: {
    Button
  }
})
export default class BottomNotification extends Vue {
  @Prop({required: true})
  buttonText: string;

  @Prop({required: true})
  onClick: () => void;

  @Prop({required: true})
  onClose: () => void;
}
